import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVideobutton = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={18} height={19} fill='none' {...props}>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M9.398 15.539h-4.74c-2.37 0-3.158-1.575-3.158-3.158V6.066c0-2.37.788-3.157 3.157-3.157h4.74c2.37 0 3.158.787 3.158 3.157v6.315c0 2.37-.795 3.158-3.157 3.158M14.64 13.049l-2.085-1.463V6.854L14.64 5.39c1.02-.712 1.86-.277 1.86.975v5.715c0 1.253-.84 1.688-1.86.968'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M8.625 8.474a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25'
    />
  </svg>
);
export default SvgVideobutton;
